import React from "react";
import Navigation from "./components/Navigation";
import Hero from "./components/Hero";
import Features from "./components/Features";
import Pricing from "./components/Pricing";
import FAQ from "./components/FAQ";
import Footer from "./components/Footer";
import Ellipse from "./components/Ellipse/Ellipse";
import Background from "./components/Background";

function App() {
  return (
    <div className="App">
      <Background>
        <Ellipse className="-top-[180rem] -left-[57rem] 2xl:-left-[0] 2xl:-top-[175rem]" />
        <Ellipse className="top-[9rem] left-[70rem] 2xl:left-[160rem]" />
        <Ellipse className="top-[110rem] -left-[165rem] 2xl:top-[180rem]" />
        <Navigation />
        <Hero />
        <Features />
        <Pricing />
        <FAQ />
        <Footer />
      </Background>
    </div>
  );
}

export default App;
